import { REDUX_REGISTER_COMPONENT, REDUX_DISPOSE_COMPONENT } from "../../core";

class StoreComponent {
  props: any;
  constructor(_props: any) {
    this.props = { ..._props };
 		REDUX_REGISTER_COMPONENT(this);
  }

  // each class should have a name for debugging purposes
  getName() {
    return 'NONAME Store Component! Please set name!';
  }

  // this gets called before updateProps(bIsMounting = true). Allocate stuff here.
	beforeMount() {}

  // internal method, do not change, do not touch!
	// called before beforeMount so it sets internal props
	initProps(newProps: any) {
		this.props = { ...this.props, ...newProps };
	}

  // internal method, do not change, do not touch!
	// it just updates the internal props with the new value without calling onPropsChange()
	updateProps(newProps: any) {
		this.props = { ...this.props, ...newProps };
	}

  // called everytime something of interest gets changed
	// bIsMounting will be true only when initializing/mounting the class, and will have the props set being called after the constructor
	// WARNING: when bMounting is true then it gets called before the constructor. Allocate stuff in beforeMount!
	onPropsChange(oldProps: any, bIsMounting: any) {}

  // call this to unregister a class. All classes must implement a dispose and must call super.dispose()
	dispose() {
		// remove component from registered component listeners
		REDUX_DISPOSE_COMPONENT(this);
	}

  // filters the state down to whatever we need.
	mapStateToProps(state: any) {
		// by default it "watches" the full state
		return state;
	}
}

export default StoreComponent;